import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import FooterContainer from 'src/components/footer/footer';
import Slider from "react-slick";

function FreedomFlyerPromo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const settings = {
        loop: true,
        arrows: true,
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 2,
        initialSlide: 0,
        centerPadding: '20px'
    };

    const domain = (brandId == 31 || brandId == 32) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7" : 'IW247';

    return (
        <>
            <InformationWrapper>
                <TitleText>
                    <img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerHeadTextImage}`} className='headTextImg' alt="image" />
                    <p>Celebrate India's <strong>78th Independence Day</strong> with<br /> <strong>{domain}</strong> and <strong>Spribe</strong> Instant Games!!</p>
                    <img src={`${config.imageV3Host}/static/cashsite/${theme.image.JiliPromoDateImg}`} className='dateImg' alt="Date" />
                    <p>Ignite your patriotic spirit by playing thrilling games like <strong>Aviator, Dice, Mines, and Goal</strong>. Climb the <br />
                    leaderboard with every real money bet and compete for a massive <strong>₹78 Lakh prize pool</strong> - honoring <br />
                    78 years of India's freedom! Fly high, rank high, and claim your share of weekly and monthly <br />rewards!</p>
                </TitleText>
                <Container className="morePadding">
                    <HowToImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPricePool}`}
                            alt="How to Join"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </HowToImageWrapper>
                    <HowToJoinStep>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerHowToParticipate}`} className='howToJoin' alt="How To Join" />
                        <ul>
                            <li><strong>Log in</strong>&nbsp;to your {domain} account.</li>
                            <li>Navigate to the&nbsp;<strong>Spribe Instant Games</strong>&nbsp;section <br />(Aviator, Dice, Mines, or Goal).</li>
                            <li>Place&nbsp;<strong>real money bets</strong>&nbsp;of at least ₹10 per game to <br />contribute to your turnover.</li>
                            <li>Watch your rank soar on the&nbsp;<strong>live leaderboard</strong>, <br />updated every 30 minutes.</li>
                            <li>Rank in the&nbsp;<strong>Top 10 weekly</strong>&nbsp;or&nbsp;<strong>Top 3 monthly</strong>&nbsp;<br />(among weekly winners) to win cash and crypto rewards!</li>
                        </ul>
                    </HowToJoinStep>
                </Container> 

                <PriceBreakDown>
                    <MainTitle>Weekly Prize Pool</MainTitle>
                    <h2 className='priceAdditnl'>₹7,80,000</h2>
                    <p className='textPadBtm'>Celebrate freedom every week with a share of the weekly prize pool! The top 10 players with the <br />highest turnover each week (Sunday-Saturday) win big:</p>
                    <SliderWrapper>
                        <Slider {...settings}>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize01}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize02}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize03}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize04}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize05}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize06}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize07}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize08}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize09}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrize10}`}/></div>
                        </Slider>
                    </SliderWrapper>
                    <div className='winnersAmt'>
                        <p>Monthly Prize Pool for Weekly Winners</p>
                        <h2>₹19,47,000</h2>
                        <p>(Paid in USDT)</p>
                    </div>
                </PriceBreakDown>

                <MonthlyPrizeWrap>
                    <MainTitle>Monthly prize (USDT Value)</MainTitle>
                    <p className='textPadBtm'>The top 3 players with the highest cumulative turnover among weekly <br /> winners across August 2025 share a grand prize pool:</p>
                    <MonthlyPrizeSec>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.freedomFlyerPrizeMonthly}`}/>
                    </MonthlyPrizeSec>
                </MonthlyPrizeWrap>
                
                <TermsConditionsSec>
                  <MainTitle>Terms & Conditions</MainTitle>
                    <ol>
                        <li>Only real money bets of <strong>₹10 or more</strong> on Spribe Instant Games (Aviator, Dice, Mines, Goal) count toward the leaderboard.</li>
                        <li>Leaderboards are based on <strong>total turnover</strong> (not winnings).</li>
                        <li><strong>Weekly prizes</strong> are paid in cash and credited by <strong>12:00 AM IST every Tuesday</strong> during the campaign period (August 1-31, 2025).</li>
                        <li><strong>Monthly prizes</strong> are paid in USDT to a valid wallet address, credited by <strong>Thursday, September 4, 2025</strong>.</li>
                        <li>Only players who rank in the top 10 weekly leaderboards (Sunday-Saturday) qualify for the monthly prize pool, based on their cumulative turnover across the month.</li>
                        <li>Winners must complete <strong>KYC verification</strong> to claim rewards.</li>
                        <li>Weekly leaderboards reset at <strong>12:00 AM IST every Sunday</strong>, the monthly leaderboard spans August 1-31, 2025.</li>
                        <li>{domain} reserves the right to disqualify players for fraudulent activity or abuse of the promotion.</li>
                        <li>Standard {domain} terms and conditions apply.</li>
                    </ol>
                </TermsConditionsSec>
            </InformationWrapper>
            <FooterContainer />
        </>
    )
}

export default withTheme(withAppContext(FreedomFlyerPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 3rem 0 0rem 0;
    margin: 0em 1.2em 1.2em 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.freedomFlyerPromoInnerBG")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        text-transform: capitalize;
        margin: 0;
    }
    
    strong {
        font-weight: 800;
    }

    .textPadBtm {
        padding-bottom: 2rem;
    }

    h2 {
        color: #FFEE00;
        text-align: center;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
`;

const HowToJoinStep = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 1rem;
    padding-left: 1rem;

    img {
        width: 335px;
        max-width: 100%;
    }

    ul {
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
        gap: 1rem;

        li {
            color: #FFF;
            text-align: left;
            font-size: 17px;
            font-style: normal;
            line-height: 150%;
            text-transform: capitalize;
            list-style-type: none;
            /* display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap; */
            padding-left: 2.5rem;
            position: relative;

            ::before {
                content: "";
                display: flex;
                width: 26.853px;
                height: 26.853px;
                background: url(${config.imageV3Host}/static/cashsite/${theme("image.freedomFlyerTik")});
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                overflow: hidden;
                position: absolute;
                left: 5px;
            }
        }
    }
`;

const HowToImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 673px;
        max-width: 100%;
    }
`;

const SliderWrapper = styled.div`
    width: 85%;
    margin: 0 auto;

    .slick-slide {
        padding: 0 15px;
    }

    .slick-slide img {
        display: block;
        width: 100%;
        transition: transform .5s; /* Animation */

        :hover {
            transform: scale(0.8);
            border: 3px solid #ffffff;
            border-radius: 1rem;
        }

        :focus-visible {
            outline: none;
        }
        :focus {
            outline: none;
        }
    }

    .slick-prev {
        left: -65px;
        top: 43%;
    }

    .slick-next {
        right: -25px;
        top: 43%;
    }

    .slick-prev:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/prevSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-next:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/nextSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-dots {
        bottom: -40px;

        li button:before {
            color: #fff;
            font-size: 15px;
            opacity: unset;
        }

        li.slick-active button:before {
            opacity: unset;
            color: #FF0000;
        }
    }
`;

const PriceBreakDown = styled.div`
    width: 80%;
    padding: 2rem 0;
    position: relative;
    margin: auto;
    text-align: center;

    .winnersAmt {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 4rem;

        h2 {
            margin: 0;
            margin-top: 10px;
        }
    }

    .priceAdditnl {
        margin: 0px 0 15px 0;
    }
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${theme('palette.liveJackpotTittleTextPadding')};
    position: relative;
    gap: 22px;
    /* margin-bottom: 2rem; */

    .dateImg {
        width: 180px;
    }

    .headTextImg {
        width: 481px;
    }
`;

const Container = styled.div`
    width: 100%;
    max-width: 1366px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0 auto;

    &.morePadding {
        padding-top: 3rem;
        padding-bottom: 2rem;
    }
`;

const MainTitle = styled.h4`
    color: #FFEE00;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;
`;

const MonthlyPrizeSec = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;

    & img {
        width: 36%;
        height: auto;
    }
`;

const MonthlyPrizeWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    margin-top: 1em;
`;

const TermsConditionsSec = styled.div`
     display: flex;
     flex-direction: column;
     align-items: center;
     gap: 5px;
    padding: 4em 0;

     & ol {
        width: 47%;
        margin-top: 5px;

        & li {
            color: #FFF;
            text-align: justify;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 30px;
            text-transform: capitalize;
            margin: 3px 0px;
            margin-bottom: 7px;
        }
     }
`;